import { makeStyles } from "@material-ui/core";

const useSharedStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2,4),
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: "#f9f9f9",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: "#04286F",
    fontWeight: 500,
  },
  formControl: {
    marginBottom: theme.spacing(1),
    width: "100%",
  },
  label: {
    fontSize: "0.8rem",
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    color: "#333",
  },
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  inputField: {
    marginTop: theme.spacing(1),
  },
  addButton: {
    margin: theme.spacing(2, 0),
        background: "linear-gradient(90deg, #0A2D71 0%, #133984 100%)",
  },
  dividendEntry: {
    position: "relative",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  deleteButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  totalSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(2, 0),
    fontWeight: "bold",
  },
  totalLabel: {
    marginRight: theme.spacing(2),
  },
  totalAmount: {
    width: "100px",
    textAlign: "right",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
  },
  requiredAsterisk: {
    color: "red",
    marginLeft: theme.spacing(0.5),
  },
}));

export default useSharedStyles;
